Intro =  {

	init : ->
		tlShowMainShape = new TimelineLite({paused:true})
		tlShowMainShape.addLabel('start')
		
		if $('.block-intro_villa'.length)
			tlShowMainShape.to $('.block-intro .shape-container svg'), 0.8, {scale: 1, x:'35%', ease:Expo.easeInOut}, 'start'
		else 
			tlShowMainShape.to $('.block-intro .shape-container svg'), 0.8, {scale: 1, ease:Expo.easeInOut}
		
		tlShowMainShape.fromTo $('.shape-container .shape--desc'), 0.4, {y:'-45%', autoAlpha:0}, {y:'-50%', autoAlpha:1, ease:Expo.easeOut}

		$('.block-intro .shape-container svg').on "mouseenter", (ev) ->
			console.log "coucou"
			tlShowMainShape.play()
			
		$('.block-intro .shape-container').on "mouseleave", (ev) ->
			tlShowMainShape.reverse()

		$('.block-intro .text-plus-container').on "mouseenter", (ev) ->
			if $('.block-intro .text-plus-container').width() > 60			
				if !$('.block-intro .text-plus-container').hasClass("open")
					$('.block-intro .text-plus-container').addClass('open')
			
		$('.block-intro .text-plus-container').on "click", (ev) ->
			
			if !$('.block-intro .text-plus-container').hasClass("open")
				$('.block-intro .text-plus-container').addClass('open')
			else
				$('.block-intro .text-plus-container').removeClass('open')
				
		#if $('.block-intro_home').length
		#
		#	$('.intro--nav .nav--list-container li').on "mouseenter", (ev) ->
		#		_this = @
		#		tlShapeHomeNav = new TimelineLite
		#		tlShapeHomeNav.to $(@).find(".start"), 0.2, {morphSVG: $(@).find(".middle"), ease:Linear.easeNone}
		#			.to $(@).find(".start"), 0.3, {morphSVG: $(@).find(".end"), ease:Quad.easeOut}
		#
		#		$(_this).on "mouseleave", (ev) ->
		#			tlShapeHomeNav.pause()
		#			TweenLite.to $(@).find(".start"), 0.6, {morphSVG: $(@).find(".start"), ease:Expo.easeInOut}


	destroy : ->
		console.log "Intro destroy"
		
}